import React, { useState } from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';

const ZipInput = (props: {
  zip: string;
  updateZip: (newZip: string) => void;
  required: boolean;
  disabled?: boolean;
  invalid?: boolean;
  formFeedback?: string;
  onBlur?: () => void;
}) => {
  const { zip, updateZip, required, disabled, onBlur } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [hasBlur, setHasBlur] = useState(false);

  const isInvalid =
    hasBlur &&
    ((!hasFocus && required && !zip.trim()) || !!props.invalid);

  const isValid =
    hasBlur &&
    !hasFocus &&
    !!zip.trim() &&
    !props.invalid;

  return (
    <FormGroup floating>
      <Input
        name="zip"
        id="zip"
        type="text"
        value={zip}
        onChange={(e) => updateZip(e.target.value)}
        onFocus={() => {
          setHasFocus(true);
          setHasBlur(false);
        }}
        onBlur={() => {
          setHasBlur(true);
          setHasFocus(false);
          onBlur?.();
        }}
        required={required}
        disabled={disabled}
        invalid={isInvalid}
        valid={isValid}
      />
      <Label for="zip" required>
        Zip
      </Label>
      <FormFeedback className="text-left">
        {isInvalid && (props.formFeedback ?? (required && !zip.trim() ? 'Zip is required.' : null))}
      </FormFeedback>
    </FormGroup>
  );
};

export default ZipInput;
